import { Injectable } from '@angular/core';
import { IAbstractPresenter } from '@core/interfaces';
import { ISingleproductHeaderComponent, ISingleproductHeaderPresenter } from './interfaces';
import { ImageViewerModalComponent } from '@/shared/components/image-viewer-modal/image-viewer-modal.component';
import { ModalController } from '@ionic/angular';
import {
  canDecreaseSingleProductQuantity,
  getSingleProductQuantityIcon,
  hasMultipleSingleProductPrices,
} from '@features/home/domain';

@Injectable()
export class SingleproductHeaderPresenter 
  extends IAbstractPresenter<ISingleproductHeaderComponent>
  implements ISingleproductHeaderPresenter 
{
  constructor(
    private modalCtrl: ModalController,
  ) {
    super();
  }

  dispatchActions(): void {}

  suscribeObservers(): void {}

  shouldShowPriceOptions(): boolean {
    const prices = this.view.formGroup.get('productosCanal.precios')?.value ?? [];
    return hasMultipleSingleProductPrices(prices.length);
  }

  quantityDecreaseIcon(): 'trash' | 'minus' {
    return getSingleProductQuantityIcon(this.view.formGroup.get('cantidad')?.value);
  }

  canDecreaseMealSelected(): boolean {
    return canDecreaseSingleProductQuantity(this.view.formGroup.get('cantidad')?.value);
  }

  decreaseMealSelected(): void {
    const current = Number(this.view.formGroup.get('cantidad')?.value ?? 1);
    if (this.canDecreaseMealSelected()) {
      this.view.formGroup.get('cantidad')?.patchValue(current - 1);
    }
  }

  increaseMealSelected(): void {
    const current = Number(this.view.formGroup.get('cantidad')?.value ?? 0);
    this.view.formGroup.get('cantidad')?.patchValue(current + 1);
  }

  async showFullImage(imageUrl: string): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ImageViewerModalComponent,
      componentProps: {
        imageUrl: imageUrl,
      },
      cssClass: 'image-viewer-modal',
      backdropDismiss: true,
    });

    await modal.present();
  }
}
